import { render, staticRenderFns } from "./Repport.vue?vue&type=template&id=85319b10&scoped=true&"
import script from "./Repport.vue?vue&type=script&lang=js&"
export * from "./Repport.vue?vue&type=script&lang=js&"
import style0 from "./Repport.vue?vue&type=style&index=0&id=85319b10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85319b10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/_AzureDevOps/Kali_easyfert/CMS/Web/easyfert/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCheckbox,VTextField})
